//#region IMPORTS
import { setInstoreThemePageNumber } from "../../features/instoreThemes/instoreThemesSlice";
import { useAppDispatch } from "../../store/configureStore";
import { InstoreTheme } from "../../models/instoreTheme";
import { MetaData } from "../../models/pagination";
import InstoreThemesTableHeader from "./InstoreThemesTableHeader";
import InstoreThemesTableRow from "./InstoreThemesTableRow";
import MainTable from "../_layout/MainTable";
//#endregion

//#region INTERFACE
interface Props {
  deleteHandler: (item: InstoreTheme) => void;
  editHandler: (item: InstoreTheme) => void;
  itemsLoaded: boolean;
  metaData?: MetaData;
  loading?: boolean;
  items: InstoreTheme[];
  hide?: boolean;
}
//#endregion

export default function InstoreThemesTable({
  deleteHandler,
  editHandler,
  itemsLoaded,
  metaData,
  loading = false,
  items,
  hide = false,
}: Props) {
  //#region SETUP
  // Redux
  const dispatch = useAppDispatch();
  //#endregion

  //#region RENDER
  return (
    <MainTable
      onPageChangeHandler={(page: number) =>
        dispatch(setInstoreThemePageNumber({ page: page }))
      }
      itemsLoaded={itemsLoaded}
      metaData={metaData}
      header={<InstoreThemesTableHeader />}
      hide={hide}
    >
      {items.map((instoreTheme) => (
        <InstoreThemesTableRow
          deleteHandler={() => deleteHandler(instoreTheme)}
          editHandler={() => editHandler(instoreTheme)}
          instoreTheme={instoreTheme}
          loading={loading}
          key={instoreTheme.id}
        />
      ))}
    </MainTable>
  );
  //#endregion
}
